<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>확인학습</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          전시관리
        </li>
        <li class="breadcrumb-item active">
          <a href="/exhibit/StudyCheck">확인학습</a>  
        </li>
      </ol>
    </div>
    <!-- 검색  -->
    <div class="card card-default" v-show="data.params.mode=='list'">
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 기간검색 -->
          <SchDateRange label="기간" :data="data" @search="gradesearch" @reset="reset" />
          <!-- 분류 -->
          <div class="form-group no-margin row" style="width:100%">
            <div class="col-auto">
              <label class="col-form-label">학교급</label>
            </div>
            <div class="col-auto">
                <b-form-select :options="schoolType.type" v-model="schoolType.text" @change="CheckSchoolLevel(schoolType.text);ChangeSelectBox();" class="custom-select custom-select-sm"></b-form-select>
            </div>
            <div class="col-auto">
              <label class="col-form-label">학년</label>
            </div>
            <div class="col-auto">
                <b-form-select :options="schLevelOption.type" v-model="schLevelOption.text" @change="ChangeSelectBox();" class="custom-select custom-select-sm"></b-form-select>
            </div>
            <div class="col-auto">
              <label class="col-form-label">과목</label>
            </div>
            <div class="col-auto">
                <b-form-select :options="schLevelSubOption.type" v-model="schLevelSubOption.text" @change="ChangeSelectBox();" class="custom-select custom-select-sm"></b-form-select>
            </div>
            <div class="col-auto">
              <label class="col-form-label">콘텐츠 유형</label>
            </div>
            <div class="col-auto">
                <b-form-select :options="fileTypeCd" v-model="fileOptionsText" @change="ChangeSelectBox();" class="custom-select custom-select-sm"></b-form-select>
            </div>
            <div class="col-auto">
              <label class="col-form-label">사용 유무</label>
            </div>
            <div class="col-auto">
              <select class="custom-select custom-select-sm custom-select" @change="ChangeSelectBox();" id="__BVID__248">
                <option value="Y">Y</option>
                <option value="N">N</option>
              </select>
            </div>
          </div>
          <!-- 항목 검색 -->
          <sch-text label="검색어" :data="data" @search="search" @reset="reset"/>
        </div>
      </div>
    </div>
    <!-- // 검색 -->

    <!-- 목록 -->
    <div v-show="data.params.mode=='list'" class="card card-default">
      <div class="card-header mt-2">
        <span class="text-bold h4">목록</span>
        <div class="card-tool float-right" >
          <b-btn class="btn btn-xs btn-outline-info mr-2" variant="outline-primary" style="width:150px;" @click="SaveChangeUse();">변경사항 프론트 반영</b-btn>
          <b-btn class="btn btn-xs btn-outline-info mr-2" variant="outline-primary" style="width:100px;" @click="ClearSelecBox();openAddPopup();" >등록</b-btn>
        </div>
        <ShowCounter label="Show" :data="data" @search="search" />
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <td style="text-align:center">No</td>
            <td style="text-align:center" @click="localSort.sort('fileTypeCd')">유형<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="localSort.sort('fileNm')">콘텐츠명<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="localSort.sort('schlGrdCd')">학교급<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="localSort.sort('subjectCd')">과목<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="localSort.sort('loginGrd')">학년<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center">교재정보<em class="fa-2s mr-2 fas"></em></td>
            <td style="text-align:center" >사용 유무<em class="fa-2s mr-2 fas"></em></td>
            <td style="text-align:center" @click="localSort.sort('updDt')">변경일<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <!-- <td style="text-align:center" @click="dataAction.sort(search,'reg_dt')">학습지수<em class="fa-2s mr-2 fas fa-sort"></em></td> -->
          </tr>
          </thead>

          <tbody>
          <tr v-show="data.count==0" class="text-center"><td colspan="9">No matching records</td> </tr>
          <tr v-show="data.count!=0" v-for="(item, index) in data.list" :key="index" > <!--  @click.prevent="edit(item.seq);" -->
            <td class="align-middle text-center">{{data.params.limit*(data.params.page-1) + index+1}}</td>
            <td class="align-middle text-center">
              <b-form-select :options="fileTypeCd" v-model="item.fileTypeCd" class="not-select custom-select custom-select-sm"></b-form-select>
            </td>
            <td class="align-middle text-center">{{item.fileNm}}</td>
            <td class="align-middle text-center">
              <b-form-select :options="schoolType.type" v-model="item.schlGrdCd" class="not-select custom-select custom-select-sm"></b-form-select>
            </td>
            <td class="align-middle text-center">
              <b-form-select :options="subjectCd" v-model="item.subjectCd" class="not-select custom-select custom-select-sm"></b-form-select>
            </td>
            <td class="align-middle text-center">{{item.loginGrd}}학년</td>
            <td class="align-middle text-center">{{item.mapLocation}}</td>
            <td class="align-middle text-center">
              <select class="custom-select custom-select-sm custom-select" v-model="item.delYn" id="__BVID__248" style="width:max-content;">
                <option value="N">Y</option>
                <option value="Y">N</option>
              </select>
            </td>
            <td class="align-middle text-center">{{item.updDt}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 -->

    <!-- 상세 -->
      <div class="instrument-detail" v-show="_dataObject.params.mode=='detail'">
          <div class="instrument-info card card-default" style="width: 98%; margin: 0 auto;">
            <div class="form-group no-margin row" style="width:100%">
              <div class="d-flex mt-3 ml-3 mb-3" style="width:100%">
                  <div class="col-auto">
                    <label class="col-form-label">학교급</label>
                  </div>
                  <div class="col-auto">
                      <b-form-select :options="schoolType.type" v-model="schoolType.text" @change="CheckSchoolLevel(schoolType.text);ChangeSelectBox();" class="custom-select custom-select-sm"></b-form-select>
                  </div>
                  <div class="col-auto">
                    <label class="col-form-label">학년</label>
                  </div>
                  <div class="col-auto">
                      <b-form-select :options="schLevelOption.type" v-model="schLevelOption.text" @change="ChangeSelectBox();" class="custom-select custom-select-sm"></b-form-select>
                  </div>
                  <div class="col-auto">
                    <label class="col-form-label">과목</label>
                  </div>
                  <div class="col-auto">
                      <b-form-select :options="schLevelSubOption.type" v-model="schLevelSubOption.text" @change="ChangeSelectBox();" class="custom-select custom-select-sm"></b-form-select>
                  </div>
                  <b-btn class="btn btn-xs btn-outline-info mr-2" variant="outline-primary" style="width:100px;" @click="openTextBook()" >교재 검색하기</b-btn>
              </div>
              <div class="d-flex justify-content-between" style="width:100%">
                   <div class="d-flex ml-3">
                      <div class="col-auto">
                        <label class="col-form-label">교재명</label>
                      </div>
                      <div class="col-auto">
                          <input type="text" class="not-text form-control" style="width:350px" v-model="textBookData.data.textbookNm" readonly/>
                      </div>
                      <div class="col-auto">
                        <label class="col-form-label">단원</label>
                      </div>
                      <div class="col-auto">
                          <b-form-select :options="textBookData.depthtype1" v-model="textBookData.depth1Nm" @change="findDepthFile(1);" class="custom-select custom-select-sm"></b-form-select>
                      </div>
                      <div class="col-auto">
                        <label class="col-form-label">차시</label>
                      </div>
                      <div class="col-auto">
                          <b-form-select :options="textBookData.depthtype2" v-model="textBookData.depth2Nm"  @change="findDepthFile(2);" class="custom-select custom-select-sm"></b-form-select>
                      </div>
                   </div>
                   <div class="d-flex ml-3 justify-content-end">
                      <div class="col-auto">
                        <label class="col-form-label">사용유무</label>
                      </div>
                      <div class="col-auto">
                        <b-form-select :options="dataDelYn" v-model="popupData.delYn" class="custom-select custom-select-sm"></b-form-select>
                      </div>
                    </div>
                </div>
            </div>
          </div>
          <div class="instrument-info card card-default book-file" style="width: 98%; margin: 30px auto 0;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="instrument-title text-bold ml-3 mt-3 pb-2" style="width:max-content;">개체</div>
              <div class="">
                <b-button @click="SetPopupData();popupShowDepth1 = true" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">개체등록</b-button>
                <b-button @click="SetPopupData();popupShowDepth2 = true" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">개체연결</b-button>
                <b-button @click="SetPopupData();popupShowDepth4 = true" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">온라인콘텐츠연결</b-button>
                <b-button v-show="!isShowfiles"  @click="clickChangeData('file'); isShowfiles = true;" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">편집</b-button>
                <b-button v-show="isShowfiles" @click="resetOrderNum('file'); isShowfiles = false; editContSeq=0;" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">취소</b-button>
                <b-button v-show="isShowfiles" @click="saveChangeOrder('file'); isShowfiles = false;" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2" >저장</b-button>
              </div>
            </div>
            <table class="table table-striped table-hover">
              <tbody class="div_scroll">
                <tr v-show="atrbInfo.files.length == 0 || atrbInfo.files.length == null  " class="text-center">
                  <td>No matching records</td>
                </tr>
              <draggable v-model="atrbInfo.files" :options="{group:'files', disabled:!isShowfiles}" @change="changeOrder(atrbInfo.files)">
                <tr v-for="(item,index) in atrbInfo.files"  :key="item.fileSeq">
                  <b-btn class="btn btn-xs mr-2 btn-down" @click="popupShowDepth6 = false; downloadAs(item.fileDivCd,item.url,item.orgFileNm)" />
                  <td class="file" scope="row" @click="atrbInfo.fileSeq = item.fileSeq; popupShowDepth6 = true;" style="width:calc(100% - 50px)">
                    <a variant="outline-info mr-2">
                      {{ item.dispFileNm }}
                    </a>
                    <em class="fa fa-edit fa-pull-right mr-2" v-if="isShowfiles" @click="editAttr(item.contSeq)"></em>
                      <b-input-group v-show="editContSeq==item.fileSeq">
                        <b-form-input type="text" v-model="item.title"></b-form-input>
                        <b-input-group-append>
                          <b-btn class="btn btn-xs mr-2" variant="warning" @click="deleteAttr(data.row.contSeq, item.mappingSeq , item.orderNum, atrbInfo, 'file')">Delete</b-btn>
                          <b-btn class="btn btn-xs mr-2" variant="info" @click="saveAttr(item.title, item.pcontSeq );">Save</b-btn>
                        </b-input-group-append>
                      </b-input-group>
                    <div class="file-kind-wrap">
                      <div class="file_kind" v-show="editContSeq!=item.fileSeq">
                        <span v-show="item.purpTypeCd != null ? true : false " :style="{color: contColor[index]}">{{contKind[index]}}</span>
                        <span v-show="item.teacherUseYn == 'Y' ? true : false " :style="{color: item.teacherUseYn == 'Y' ? '#FF0000' : '' }">교사</span>
                        <span v-show="item.tutorUseYn == 'Y' ? true : false " :style="{color: item.tutorUseYn == 'Y' ? '#708090' : '' }">강사</span>
                        <span v-show="item.studentUseYn == 'Y' ? true : false " :style="{color: item.studentUseYn == 'Y' ? '#800000' : '' }">학생</span>
                      </div>
                      <div class="file_kind" v-show="editContSeq!=item.fileSeq">
                        <span v-show="item.fileTypeCd == '211006' ? true : false">(온라인 콘텐츠)</span>
                      </div>
                    </div>
                  </td>
                </tr>
              </draggable>
              </tbody>
            </table>
          </div>
          <div class="footer mt-3 mb-3 mr-1">
          <div class="float-right">
            <b-button @click="search()" class="btn btn-b btn-outline-info mr-2" variant="outline-info mr-2">목록</b-button>
          </div>
        </div>
       </div>
      <div>
    </div>
    <!-- // 목차/차시 -->
    <b-modal id="anniversary" size="s" title="교과서 검색" v-model="popupShowFindBook" hide-footer>
      <StudyFindTextBook :schLevelSubOption="schLevelSubOption" :schLevelOption="schLevelOption" @set-txt="setTextBook" @modal-state="popupClose"/>
      <loading :active="modalLoading" :is-full-page="true"/>
    </b-modal> 
     <b-modal id="fileRegModal" size="xl" title="개체등록" v-model="popupShowDepth1" hide-footer>
      <StudyCheckFileUpload :popupData="popupData" @modal-state="popupClose" @refresh="refresh"/>
      <loading :active="modalLoading" :is-full-page="true"/>
    </b-modal>
    <b-modal id="uploadModalFiles" size="xl" title="개체연결" v-model="popupShowDepth2" hide-footer>
      <StudyCheckFile :popupData="popupData" @modal-state="popupClose" @refresh="refresh" />
      <loading :active="modalLoading" :is-full-page="true"/>
    </b-modal>
    <b-modal id="uploadModalFiles" size="xl" title="온라인콘텐츠연결" v-model="popupShowDepth4" hide-footer>
      <StudyCheckFileOnline :popupData="popupData" @modal-state="popupClose" @refresh="refresh"/>
      <loading :active="modalLoading" :is-full-page="true"/>
    </b-modal>
    <!--  <b-modal id="usingModalFiles" size="xl" title="개체용도변경" v-model="popupShowDepth3" hide-footer>
      <StudyCheckFile :popupData="popupData" :key="atrbInfo.contSeq"/>
      <loading :active="modalLoading" :is-full-page="true"/>
    </b-modal> -->
    <!--<b-modal id="fileModal" size="xl" title="개체정보" v-model="popupShowDepth6" hide-footer>
      <CsFilePageInfo :fileSeq="atrbInfo.fileSeq" :contSeq="SelectData.momentContList.contSeq" :isShow="isShow" @modal-state="popupClose" @reloading="refresh" key="atrbInfo.fileSeq" :parentType="'txt'" :saveType="'ins'"/>
      <loading :active="modalLoading" :is-full-page="true"/>
    </b-modal> -->
  </ContentWrapper>
</template>
<script>
import Vue from 'vue'
import { reactive, ref, computed, onMounted, onUnmounted ,onBeforeMount} from '@vue/composition-api'
import {getLmTextBookList,getLmTextBookItem,saveLmTextBook,deleteLmTextBook, saveTextbook,getLmTextBookListSchlGrade} from "@/api/lm/LmTextBookApi";
import {getTextbookAtrbRelInfoList} from "@/api/ext/TextbookAtrbRelInfoApi";
import {getContentsMstList} from "@/api/ext/ContentsMstApi"
import {getStudyCheck,saveCheckStudy,getStudyLmTextBook,getStudyLmTextBookDepth1,getStudyLmTextBookDepth2,getFindStudyCheckFile} from "@/api/exhibit/studycheck/StudyCheckApi"
import {getCsContList, getCsContTreeList, getCsContItem, saveCsCont, deleteCsCont, saveCsContList,saveCsContExcel, deleteCsContByOrgContSeq} from "@/api/cs/CsContApi";
import {getCsFileList, getCsFileListByMapp, saveCsFile} from "@/api/cs/CsFileApi";
import {saveCsFileMapping, saveCsFileMappingList,deleteCsFileMapping} from "@/api/cs/CsFileMappingApi";
import {getNoticeList} from "@/api/notice/NoticeListApi";
import {getSsoAdmList} from "@/api/sso/SsoAdmApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import {dataObject,bookTypeCd,subjectCd,purpTypeCd,subjectCd1,subjectCd2,subjectCd3,aws_cdn_path,fileTypeCd} from "@/utils/Constants";
import CsFileUploadPage from "../cs/CsFileUploadPage"
import CsFileUsingPage from "../cs/CsFileUsingPage"
import CsTextBookFiles from "../cs/CsTextBookFiles"
import CsFilePageInfo from "../cs/CsFilePageInfo"
import StudyCheckFile from "../exhibit/popup/StudyCheckFile"
import StudyCheckFileOnline from "../exhibit/popup/StudyCheckFileOnline"
import StudyFindTextBook from "../exhibit/popup/StudyFindTextBook"
import StudyCheckFileUpload from "../exhibit/popup/StudyCheckFileUpload"
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";
import ShowCounter from "../../components/Common/ShowCounter";
import Datepicker from 'vuejs-datepicker'
import swal from 'sweetalert2'
import Axios from 'axios';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import draggable from 'vuedraggable'
// 목차/차시/파일

import VueQuillEditor from 'vue-quill-editor'

import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme

Vue.use(VueQuillEditor, /* { default global options } */)

export default {
  components: {SchDateRange, SchText, ShowCounter, Pagenation,  Loading, draggable, Datepicker, CsFileUploadPage ,CsFilePageInfo,StudyCheckFile,StudyCheckFileOnline, StudyFindTextBook,StudyCheckFileUpload,draggable},

  setup(props, {root}){
    const selectedContSeq = '';
    const unit = "unit";
    const unit_seq = "unit_seq";
    const isShow = true;
    const isShowfiles = false;
    const popupShowDepth1 = ref(false);
    const popupShowDepthSmall = ref(false);
    const popupShowDepth2 = ref(false); 
    const popupShowDepth3 = ref(false); //개체등록
    const popupShowDepth4 = ref(false); //개체연결
    const popupShowDepth5 = ref(false); //개체용도변경
    const popupShowDepth6 = ref(false); //온라인콘텐츠
    const popupShowFile = ref(false); //개체정보
    const popupShowFindBook = ref(false);
    const useYn = ref('');

    const popupData = reactive({ //팝업 넘길때 같이 넘기는 데이터(개체연결 및 온라인개체연결)
      schlGrdCd :'',
      loginGrd :'',
      bookSeq : '',
      contSeq : '',
      subContSeq : '',
      subjectCd : '',
      delYn : 'N',
    });

    const dataDelYn = ref([
        {value:'N', text:'Y'},
        {value:'Y',text:'N'}
      ]);

    const contKind = ref([]);
    const contColor = ref([]);

    const fileName = ref('');


    //학교급, 학년 선언
    const schoolType = ref({
      text : '',
      type : [
        {value:'',text:'전체'},
        {value:'301002',text:'초등'},
        {value:'301003',text:'중등'},
        {value:'301004',text:'고등'}
      ]
    });
    const schoolLevel1 = ref({
      text : 1,
      type : [
        {value:1,text:'1학년'},
        {value:2,text:'2학년'},
        {value:3,text:'3학년'},
        {value:4,text:'4학년'},
        {value:5,text:'5학년'},
        {value:6,text:'6학년'},
      ],
    });
    const schoolLevel2 = ref({
      text : 1,
      type : [
        {value:1,text:'1학년'},
        {value:2,text:'2학년'},
        {value:3,text:'3학년'},
      ],
    });
    const schoolLevel3 = ref({
      text :1,
      type : [
        {value:1,text:'1학년'},
        {value:2,text:'2학년'},
        {value:3,text:'3학년'},
      ],
    });
    
    //학교급에 따른 학교레벨 값
    const schLevelOption = ref({
      text :null,
      type : [
        {value:null,text:'학교급을 선택해주세요.'},
      ],
    });
    const schLevelSubOption = ref({
      text : null,
      type : [
        {value:null,text:'학년을 선택해주세요.'},
      ]
    });

    const textBookData = ref({
      data : {},
      depth1Nm : '',
      depth2Nm : '',
      depthtype1 : [
        {value:'',text:'단원을 선택해주세요.'},
      ],
      depthtype2 : [
        {value:'',text:'단원을 선택해주세요.'},
      ],
    });

    const atrbInfo = reactive({
      files:[],  // 개체
      fileSeq:'',
    })

    //과목 텍스트
    const fileOptionsText = ref('');
    const _dataObject = _.cloneDeep(dataObject);
    const data = reactive(_dataObject)

    const tempData = []; //변경될 값 
    const changeData = []; //취소될 값 


    const saveUnitInfo = reactive({
      data: {},
      depth : '',
      orderNum : '',
    })

    const modalLoading = ref(false);

    const loadData = async () => {
      let result = await getStudyCheck(data.params);
      data.list = result.data;
      data.count = result.count;
      root.$_localSort.set(data.list);
    }


    const popupClose = (version) =>{ //b-modal 팝업 닫는 함수
      if(version == "addfile"){
        popupShowDepth1.value = false;
        
      }else if(version == "2"){
        popupShowDepth2.value = false;
      }
      else if(version == '3'){
        popupShowDepth3.value = false;
      }
      else if(version == '4'){
        popupShowDepth4.value = false;
      }
      else if(version == '5'){
        popupShowDepth5.value = false;
      }
      else if(version == "findtxt"){
        popupShowFindBook.value = false;
      }
    }  


    const openAddPopup = async() =>{
    
      data.params.mode="detail";
    }

    const checkColor = (item) =>{
      switch(item){
        case '209001' : 
        contKind.value = '수업용1';
        contColor.value = "#008000";
        break;

        case '209002' :
        contKind.value = '수업용2';
        contColor.value = "#0000FF";
        break;

        case '209003' : 
        contKind.value = '과제용';
        contColor.value = "#800080";
        break;

        case '209004' :
        contKind.value = '평가용';
        contColor.value = "#FF8C00";
        break;

        case '209005' : 
        contKind.value = '연구용';
        contColor.value = "#FF00FF";
        break;   
       }
    };

    const CheckSchoolLevel = (name) => {
      switch(name){
        case '301002' : 
          schLevelOption.value = _.cloneDeep(schoolLevel1.value);
          schLevelSubOption.value.type = subjectCd1;
          break;
        case '301003' : 
          schLevelOption.value = _.cloneDeep(schoolLevel2.value);
          schLevelSubOption.value.type = subjectCd2;
          break;
        case '301004' : 
          schLevelOption.value = _.cloneDeep(schoolLevel3.value);
          schLevelSubOption.value.type = subjectCd3;
          break;
        case '':
          schLevelOption.value.type =[{value:null,text:'학교급을 선택해주세요.'}]
          schLevelOption.value.text = null;
          schLevelSubOption.value.type =[{value:null,text:'학년을 선택해주세요.'}]
          schLevelSubOption.value.text = null;
          break;
      }
    }

      const ChangeSelectBox = async() =>{ //리스트 화면 검색부분 
         textBookData.value.data.textbookNm = '';
         data.params.schlGrdCd = schoolType.value.text;
         data.params.subjectCd = schLevelSubOption.value.text;
         data.params.fileTypeCd = fileOptionsText.value;
         data.params.delYn = useYn.value;

         if(schoolType.value.text == '301002'){
           data.params.loginGrd = schoolLevel1.value.text;
         }else if(schoolType.value.text == '301003'){
           data.params.loginGrd = schoolLevel2.value.text;
         }else if(schoolType.value.text == '301004'){
           data.params.loginGrd = schoolLevel3.value.text;
         }else{
           data.params.loginGrd = null;
           data.params.schlGrdCd = null;
          data.params.subjectCd  = null;
         }
        
         data.params.page = 1;
         let _params = data.params;
         let result = await getStudyCheck(_params);
         data.list = result.data;
         data.count = result.count;
         root.$_localSort.set(data.list);
     }

    const ClearSelecBox = () => { //등록시 selectBox 초기화
      schoolType.value.text = '';
      schLevelOption.value.text = null;
      schLevelSubOption.value.text = '';
    }

    const SaveChangeUse = async() =>{
      let params = [];
        data.list.map((row,i) =>{
          let param = {
             studySeq : row.studySeq,
             delYn : row.delYn,
          }
          params.push(param);
        });
      let result = await saveCheckStudy(params);
      swal({
        title: "변경사항 반영 완료 ",
        text: "사용유무 변경사항 프론트 반영이 완료되었습니다. ",
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "OK",
        heightAuto: false
      }).then((result) => {
      });
    }

    const setTextBook = async(item) =>{ //팝업 교과서 선택 후 단원찾는 부분
      textBookData.value.data = item;
      modalLoading.value = true;
      
      let resultTextBook = await getStudyLmTextBookDepth1({
        pContSeq : item.contSeq,
        contTypeCd : '201002',
      })
      swal({
        title: "교재 선택 완료",
        text: "데이터 내려받기 완료",
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "OK",
        heightAuto: false
      }).then((result) => {
        modalLoading.value = false;
        popupShowFindBook.value = false;
        textBookData.value.depthtype1 = [{value:'',text:'단원을 선택해주세요.'}];
        resultTextBook.data.map((row,i)=>{
          textBookData.value.depthtype1.push({
            value : row.contSeq,
            text : row.title,
          })
        });
      });
      
    }

    const findDepthFile = async(depth) =>{
      let depthContSeq = depth ==  1 ? textBookData.value.depth1Nm : textBookData.value.depth2Nm ;
      if(depth == 1 ){
         modalLoading.value = true;
        let resultDepth2 = await getStudyLmTextBookDepth2({
          pContSeq : textBookData.value.depth1Nm,
          contTypeCd : '201002',
        });
        swal({
          title: "단원 선택 완료",
          text: "차시 내려받기 완료",
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "OK",
          heightAuto: false
        }).then((result) => {
          modalLoading.value = false;
          textBookData.value.depthtype2 = [{value:'',text:'단원을 선택해주세요.'}];
          textBookData.value.depth2Nm = '';
          resultDepth2.data.map((row,i)=>{
            textBookData.value.depthtype2.push({
              value : row.contSeq,
              text : row.title,
            })
          });
        });
        let fileResult = await getFindStudyCheckFile({
          contSeq : depthContSeq,
        });
        atrbInfo.files = _.cloneDeep(fileResult.data); 
      }
      else{
        let fileResult = await getFindStudyCheckFile({
          subContSeq : depthContSeq,
        });
        atrbInfo.files = _.cloneDeep(fileResult.data); 
      }

    }

    const SetPopupData = () =>{
      popupData.schlGrdCd = schoolType.value.text;
      popupData.loginGrd = schLevelOption.value.text;
      popupData.bookSeq = textBookData.value.data.bookSeq;
      popupData.contSeq = textBookData.value.depth1Nm;
      popupData.subContSeq = textBookData.value.depth2Nm;
      popupData.subjectCd = schLevelSubOption.value.text;
    }

    const refresh = async(item) =>{
      let param = {};
      if( item.subContSeq == null || item.subContSeq == ''){
        param = await{
          contSeq : item.contSeq,
        }
      }else{
        param = await{
          subContSeq : item.subContSeq,
        }
      }
      let result = await getFindStudyCheckFile(param);

      if(result.data.length > 0){
        atrbInfo.files = [];
        atrbInfo.files = result.data;
      }

      if(item.version == "2"){
        popupShowDepth2.value = false;
      }
      else if(item.version == '3'){
        popupShowDepth3.value = false;
      }
      else if(item.version == '4'){
        popupShowDepth4.value = false;
      }
      else if(item.version == 'addfile'){
        popupShowDepth1.value = false;
      }
    }

    const openTextBook = () =>{
      if(schoolType.value.text == '' || schLevelOption.value.text == null || schLevelSubOption.value.text ==null){
        alert("학교급, 학년, 과목을 모두 선택 해주세요.");
      }else{
        popupShowFindBook.value=true;
      }
    }


    onMounted(loadData);


    return{
      data,
      useYn,
      selectedContSeq,
      bookTypeCd,
      subjectCd,
      subjectCd1,
      subjectCd2,
      subjectCd3,
      fileTypeCd,
      schoolLevel1,
      schoolLevel2,
      schoolLevel3,
      schLevelOption,
      schLevelSubOption,
      ClearSelecBox,
      schoolType,
      contKind,
      contColor,
      fileName,
      changeData,
      fileOptionsText,
      _dataObject,
      dataDelYn,
      ...methods(),
      dataAction: new TableActionClass(data),
      localSort:root.$_localSort,
      modalLoading,
      atrbInfo,
      saveUnitInfo,
      bookId:'',
      editContSeq:0,
      isShowfiles,
      unit,
      unit_seq,
      popupClose,
      popupShowDepth1,
      popupShowDepth2,
      popupShowDepth3,
      popupShowDepth4,
      popupShowDepth5,
      popupShowDepth6,
      popupShowFile,
      popupShowDepthSmall,
      popupShowFindBook,
      isShow,
      checkColor,
      openAddPopup,
      popupData,
      purpTypeCd,
      CheckSchoolLevel,
      ChangeSelectBox,
      SaveChangeUse,
      setTextBook,
      textBookData,
      findDepthFile,
      SetPopupData,
      refresh,
      openTextBook,
    }
  },
}

function methods() {
  var context = {};
  context["getLmTextBookList"] = getLmTextBookList;  // get list
  context["getLmTextBookItem"] = getLmTextBookItem;  // get item
  context["deleteLmTextBook"] = deleteLmTextBook;  // delete item
  context["saveLmTextBook"] = saveLmTextBook;  // save item
  context["saveCsCont"] = saveCsCont;  // save Cont item
  context["deleteCsCont"] = deleteCsCont;  // delete Cont item
  context["saveCsContList"] = saveCsContList;  // save item 
  context["saveCsContExcel"] = saveCsContExcel;  // save item 
  context["deleteCsContByOrgContSeq"] = deleteCsContByOrgContSeq;  // delete Cont item
  context["saveCsFileMapping"] = saveCsFileMapping; // save mapping info
  context["saveCsFileMappingList"] = saveCsFileMappingList; // save mapping info list
  context["getSsoAdmList"] = getSsoAdmList;  // get list  
  context["getLmTextBookListSchlGrade"] = getLmTextBookListSchlGrade; // save mapping info list
  context["getContentsMstList"] = getContentsMstList; 
  context["getNoticeList"] = getNoticeList;
  context["getStudyCheck"] = getStudyCheck;  
  context["saveCheckStudy"] = saveCheckStudy;  
  context["getStudyLmTextBookDepth1"] = getStudyLmTextBookDepth1;  
  context["getStudyLmTextBookDepth2"] = getStudyLmTextBookDepth2;  
  context["getFindStudyCheckFile"] = getFindStudyCheckFile;  

  async function search(){
    this.atrbInfo.files = [];
    this.schoolType.text='';
    this.schLevelOption.type =[{value:null,text:'학교급을 선택해주세요.'}]
    this.schLevelOption.text = null;
    this.schLevelSubOption.type =[{value:null,text:'학년을 선택해주세요.'}]
    this.schLevelSubOption.text = null;
    this.data.params.schlGrdCd = '';
    this.data.params.subjectCd = '';
    this.textBookData.data.textbookNm = '';
    this.data.params.loginGrd = null;

    let _params = this.data.params;
    await this.dataAction.execute("getStudyCheck",context,_params);
    this.localSort.set(this.data.list);
  }
   // 초기화
  async function reset(){
    this.dataAction.clear();
  }
  // 목록
  async function gradesearch(data) {
    let _params = this.data.params;
    this.dataAction.execute("getStudyCheck",context,_params);
  }

  //드래그 순서 변경 함수 
  function changeOrder(atrbInfo) {
     let _temp = []; // 최종 orderNum
     let _tempData = [];
      
      for(var i = 0; i < this.changeData.length; i++){
         _temp[i] = this.changeData[i].orderNum;
      }

      for(var i = 0; i< atrbInfo.length; i++){
        _tempData.push(atrbInfo[i]);
        _tempData[i].orderNum = _temp[i];
      }
  }

  //드래그 순서 저장 함수 
  function saveChangeOrder(depth) {
     if(depth == 'depth1'){
        saveCsContList(this.atrbInfo.depth1);
        this.changeData = _.cloneDeep(this.atrbInfo.depth1);
      }
      else if(depth == 'depth2'){
        saveCsContList(this.atrbInfo.depth2);
        this.changeData = _.cloneDeep(this.atrbInfo.depth2);
      } 
      else{
        saveCsFileMappingList(this.atrbInfo.files);
        this.changeData = _.cloneDeep(this.atrbInfo.files);
      }
  }

  //드래그 순서 편집 함수 
  function clickChangeData(depth) {  
       if(depth == 'depth1'){
        this.changeData = _.cloneDeep(this.atrbInfo.depth1);
      }
      else if(depth == 'depth2'){
        this.changeData = _.cloneDeep(this.atrbInfo.depth2);
      }
      else{
        this.changeData = _.cloneDeep(this.atrbInfo.files);
      }
  }

  //드래그 순서 취소 함수 
  function resetOrderNum(depth) {  
    if(depth == 'depth1'){
      this.atrbInfo.depth1 = _.cloneDeep(this.changeData);
    }else if(depth == 'depth2'){
      this.atrbInfo.depth2 = _.cloneDeep(this.changeData);
    }else{
      this.atrbInfo.files = _.cloneDeep(this.changeData);
    }
  }

  function editAttr(_contSeq) {
    this.editContSeq = this.editContSeq==_contSeq?0:_contSeq;
  }


const downloadAs = (fileDivCd, url, name) => {
        let fullUrl = aws_cdn_path + url;
        Axios.get(fullUrl, {
        headers: {
          "Content-Type": "application/octet-stream"
        },
        responseType: "blob"
      })
        .then(response => {
          const a = document.createElement("a");
          const url = window.URL.createObjectURL(response.data);
          a.href = url;
          a.download = name;
          a.click();
        })
        .catch(err => {
          console.log("error", err);
        });
    };
    

  return {
    clickChangeData,
    resetOrderNum,
    saveChangeOrder,
    downloadAs,
    search,
    reset,
    gradesearch,
    }
}

</script>
